import { fraseDaRecusa } from 'dashboard/helper/recusaDoAcesso';

// ACESSO-01 (L9b): o que o modal da pessoa usa com a chave ACESSO_GRANULAR ligada.

// O papel no select (`modelo:<chave>` ou `papel:<id>`), a partir do `agent.papel` da API de agentes.
export const valorDoPapel = papel =>
  papel.tipo === 'papel' ? `papel:${papel.id}` : `modelo:${papel.chave}`;

// O que a API de agentes recebe para atribuir o papel escolhido no select.
export const corpoDoPapel = valor => {
  const [tipo, chave] = valor.split(':');
  return tipo === 'papel'
    ? { papel_id: Number(chave) }
    : { papel_modelo: chave };
};

// A frase de uma falha: a recusa do acesso (403), ou a do 422, que vem no `error` da regra ou no `message` da
// validação; senão, a frase da ação. O `error` dos outros erros é texto em inglês para quem depura.
export const fraseDaFalha = (erro, fraseDaAcao) => {
  const { status, data } = erro?.response || {};
  return (
    fraseDaRecusa(erro) ||
    (status === 422 && (data?.error || data?.message)) ||
    fraseDaAcao
  );
};

// O Enter num campo do "Onde atua" ou das exceções, que gravam sozinhos, não envia o formulário do modal, que salvaria o
// agente e o fecharia.
export const segurarOEnter = evento => {
  if (evento.target.tagName === 'INPUT') evento.preventDefault();
};
